// GENERATED by scripts/geo/build-localities.py from data/geo/il-localities.json — do not edit by hand.
// Source: CBS localities file bycode2024.xlsx (coordinates ITM EPSG:2039 → WGS84), cross-checked with OpenStreetMap
// (1160 of 1326 matched; median gap < 1 km). Tuple: [name, lat, lng, population, CBS code].
export const GEO_LOCALITIES: ReadonlyArray<readonly [string, number, number, number, number]> = [
  ["ירושלים", 31.78381, 35.22047, 1050151, 3000],
  ["תל אביב -יפו", 32.07638, 34.78933, 494900, 5000],
  ["חיפה", 32.80375, 35.00929, 297083, 4000],
  ["פתח תקווה", 32.08505, 34.88632, 270403, 7900],
  ["ראשון לציון", 31.96899, 34.79975, 259275, 8300],
  ["נתניה", 32.31609, 34.86253, 234812, 7400],
  ["בני ברק", 32.08670, 34.83478, 229995, 6100],
  ["אשדוד", 31.79538, 34.64939, 228562, 70],
  ["באר שבע", 31.25382, 34.78497, 223587, 9000],
  ["חולון", 32.01647, 34.77891, 191829, 6600],
  ["בית שמש", 31.73178, 34.98828, 176786, 2610],
  ["רמת גן", 32.06886, 34.82417, 172242, 8600],
  ["אשקלון", 31.67039, 34.57409, 166865, 7100],
  ["רחובות", 31.89168, 34.80789, 155050, 8400],
  ["בת ים", 32.01974, 34.74991, 129495, 6200],
  ["הרצלייה", 32.16984, 34.83295, 110885, 6400],
  ["חדרה", 32.43555, 34.91834, 107974, 6500],
  ["מודיעין-מכבים-רעות", 31.89609, 35.00942, 100052, 1200],
  ["כפר סבא", 32.18119, 34.91280, 99410, 6900],
  ["לוד", 31.95101, 34.88839, 94189, 7000],
  ["מודיעין עילית", 31.93198, 35.04390, 89627, 3797],
  ["רמלה", 31.92778, 34.86660, 86052, 8500],
  ["רעננה", 32.18562, 34.87002, 82963, 8700],
  ["ראש העין", 32.09448, 34.95867, 79023, 2640],
  ["רהט", 31.39048, 34.75464, 77996, 1161],
  ["נצרת", 32.70206, 35.29455, 75704, 7300],
  ["קריית גת", 31.61118, 34.76615, 72139, 2630],
  ["ביתר עילית", 31.69482, 35.11250, 71698, 3780],
  ["נהרייה", 33.00844, 35.09766, 67877, 9100],
  ["הוד השרון", 32.15219, 34.89413, 66398, 9700],
  ["עפולה", 32.61695, 35.30201, 66362, 7700],
  ["קריית אתא", 32.80423, 35.10871, 62584, 6800],
  ["אום אל-פחם", 32.52045, 35.15174, 60210, 2710],
  ["גבעתיים", 32.07136, 34.80994, 58600, 6300],
  ["יבנה", 31.87672, 34.73675, 58090, 2660],
  ["נתיבות", 31.42234, 34.58307, 56019, 246],
  ["אילת", 29.55296, 34.94317, 56004, 2600],
  ["עכו", 32.92846, 35.08456, 52884, 7600],
  ["טבריה", 32.78752, 35.52353, 52122, 6700],
  ["קריית מוצקין", 32.83620, 35.08012, 51488, 8200],
  ["אלעד", 32.05111, 34.95661, 50845, 1309],
  ["רמת השרון", 32.13939, 34.84139, 48860, 2650],
  ["כרמיאל", 32.91101, 35.29163, 47941, 1139],
  ["נס ציונה", 31.92631, 34.79784, 47268, 7200],
  ["קריית ביאליק", 32.83853, 35.09019, 47072, 9500],
  ["טייבה", 32.26478, 35.00653, 46870, 2730],
  ["פרדס חנה-כרכור", 32.47311, 34.97562, 46601, 7800],
  ["נוף הגליל", 32.70860, 35.32337, 45805, 1061],
  ["קריית אונו", 32.06036, 34.85716, 45048, 2620],
  ["שפרעם", 32.80632, 35.17188, 43858, 8800],
  ["קריית ים", 32.84880, 35.07206, 41959, 9600],
  ["חריש", 32.46039, 35.04781, 41574, 1247],
  ["אור יהודה", 32.02958, 34.85389, 41130, 2400],
  ["אופקים", 31.30652, 34.62082, 39894, 31],
  ["דימונה", 31.07034, 35.03609, 39590, 2200],
  ["צפת", 32.96419, 35.50532, 38687, 8000],
  ["באר יעקב", 31.94202, 34.83904, 37493, 2530],
  ["שדרות", 31.52901, 34.59434, 37239, 1031],
  ["טמרה", 32.85417, 35.18960, 36919, 8900],
  ["מעלה אדומים", 31.78032, 35.30730, 35845, 3616],
  ["סח'נין", 32.86465, 35.29917, 33726, 7500],
  ["טירת כרמל", 32.76120, 34.97124, 32166, 2100],
  ["יהוד-מונוסון", 32.03320, 34.88639, 32145, 9400],
  ["גדרה", 31.81204, 34.78022, 31389, 2550],
  ["באקה אל-גרביה", 32.41994, 35.04150, 31276, 6000],
  ["כפר יונה", 32.31541, 34.93330, 29820, 168],
  ["ערד", 31.25884, 35.21397, 29505, 2560],
  ["גבעת שמואל", 32.07687, 34.85030, 29405, 681],
  ["מגדל העמק", 32.67799, 35.24282, 28431, 874],
  ["כפר קאסם", 32.11548, 34.97265, 27997, 634],
  ["קריית מלאכי", 31.73206, 34.74533, 27957, 1034],
  ["טירה", 32.23381, 34.95544, 27680, 2720],
  ["עראבה", 32.85158, 35.33802, 27175, 531],
  ["מבשרת ציון", 31.79984, 35.15123, 26534, 1015],
  ["אור עקיבא", 32.50776, 34.91984, 25922, 1020],
  ["גני תקווה", 32.06012, 34.87503, 25487, 229],
  ["כפר כנא", 32.74607, 35.34210, 25375, 509],
  ["קלנסווה", 32.28855, 34.97700, 25167, 638],
  ["גן יבנה", 31.78833, 34.70844, 25144, 166],
  ["גבעת זאב", 31.85593, 35.16698, 25105, 3730],
  ["יקנעם עילית", 32.64660, 35.09408, 24928, 240],
  ["תל שבע", 31.24849, 34.86060, 24781, 1054],
  ["קריית שמונה", 33.21316, 35.57461, 24437, 2800],
  ["זכרון יעקב", 32.57045, 34.95265, 24200, 9300],
  ["שוהם", 31.99766, 34.94521, 23592, 1304],
  ["מגאר", 32.88705, 35.41222, 23486, 481],
  ["מעלות-תרשיחא", 33.01434, 35.27758, 23042, 1063],
  ["חורה", 31.29728, 34.93613, 23035, 1303],
  ["נשר", 32.76851, 35.04167, 22897, 2500],
  ["קדימה-צורן", 32.28038, 34.91979, 22655, 195],
  ["כפר מנדא", 32.80994, 35.26058, 22267, 510],
  ["אריאל", 32.10428, 35.18749, 22190, 3570],
  ["כסיפה", 31.24364, 35.08918, 21849, 1059],
  ["ערערה-בנגב", 31.15845, 35.02339, 21259, 1192],
  ["כפר קרע", 32.50539, 35.05082, 21067, 654],
  ["ערערה", 32.49995, 35.08978, 20733, 637],
  ["ריינה", 32.72090, 35.31163, 20654, 542],
  ["בית שאן", 32.49491, 35.49699, 20253, 9200],
  ["ג'דיידה-מכר", 32.92959, 35.14682, 20232, 1292],
  ["לקיה", 31.32413, 34.86741, 19361, 1060],
  ["קריית טבעון", 32.71523, 35.12580, 19157, 2300],
  ["יפיע", 32.68464, 35.27590, 18837, 499],
  ["דאלית אל-כרמל", 32.69364, 35.05123, 18363, 494],
  ["ירכא", 32.95505, 35.20759, 16823, 502],
  ["שגב-שלום", 31.19701, 34.83922, 16736, 1286],
  ["מזכרת בתיה", 31.85096, 34.84359, 16334, 28],
  ["ג'סר א-זרקא", 32.53651, 34.91177, 15823, 541],
  ["בנימינה-גבעת עדה", 32.52151, 34.96205, 15566, 9800],
  ["מעלה עירון", 32.55155, 35.15579, 15486, 1327],
  ["מג'ד אל-כרום", 32.92105, 35.25451, 15429, 516],
  ["אבן יהודה", 32.27106, 34.88578, 15370, 182],
  ["אכסאל", 32.68162, 35.32452, 15134, 478],
  ["רכסים", 32.75172, 35.10135, 15087, 922],
  ["טורעאן", 32.77651, 35.37549, 14931, 498],
  ["תל מונד", 32.25279, 34.91737, 14771, 154],
  ["אבו סנאן", 32.96064, 35.16918, 14543, 473],
  ["עין מאהל", 32.72211, 35.35297, 14029, 532],
  ["נחף", 32.93496, 35.31776, 13996, 522],
  ["אעבלין", 32.82667, 35.18518, 13634, 529],
  ["פוריידיס", 32.59798, 34.95241, 13548, 537],
  ["עספיא", 32.71644, 35.06566, 13403, 534],
  ["אזור", 32.02353, 34.80736, 13067, 565],
  ["ג'ת", 32.39984, 35.03546, 12835, 628],
  ["דייר אל-אסד", 32.93617, 35.26707, 12620, 490],
  ["כאבול", 32.86995, 35.20872, 12589, 504],
  ["בית ג'ן", 32.96417, 35.37796, 12446, 480],
  ["אפרת", 31.66622, 35.15905, 12115, 3650],
  ["בסמ\"ה", 32.53031, 35.10459, 12002, 1326],
  ["ירוחם", 30.98771, 34.92770, 11989, 831],
  ["עתלית", 32.69205, 34.94336, 11611, 53],
  ["מיתר", 31.32777, 34.93098, 11609, 1268],
  ["קריית עקרון", 31.86139, 34.82306, 11283, 469],
  ["מג'דל שמס", 33.26360, 35.77023, 11264, 4201],
  ["ביר אל-מכסור", 32.78238, 35.22215, 11068, 998],
  ["חצור הגלילית", 32.98321, 35.54393, 11013, 2034],
  ["ג'לג'וליה", 32.15194, 34.95261, 10992, 627],
  ["דבורייה", 32.69135, 35.37157, 10830, 489],
  ["דייר חנא", 32.86277, 35.36846, 10762, 492],
  ["בועיינה-נוג'ידאת", 32.80780, 35.36839, 10630, 482],
  ["קרני שומרון", 32.16940, 35.09205, 10541, 3640],
  ["כפר יאסיף", 32.95383, 35.16304, 10527, 507],
  ["צור הדסה", 31.71635, 35.09636, 10458, 1113],
  ["אורנית", 32.13106, 34.99338, 10088, 3760],
  ["כסרא-סמיע", 32.96886, 35.30406, 9549, 1296],
  ["זרזיר", 32.72489, 35.22244, 9149, 975],
  ["עילוט", 32.71755, 35.26160, 9077, 511],
  ["כוכב יאיר", 32.22158, 34.99575, 9007, 1224],
  ["אבו גוש", 31.80603, 35.11011, 8847, 472],
  ["שער שומרון", 32.12177, 35.03180, 8836, 3826],
  ["משהד", 32.73998, 35.32314, 8822, 520],
  ["בענה", 32.92914, 35.27315, 8713, 483],
  ["ראמה", 32.93834, 35.36709, 8406, 543],
  ["בסמת טבעון", 32.74002, 35.14882, 8268, 944],
  ["שלומי", 33.07586, 35.14830, 8226, 812],
  ["עומר", 31.26780, 34.85056, 8077, 666],
  ["אלפי מנשה", 32.17363, 35.01356, 8038, 3750],
  ["להבים", 31.36906, 34.81251, 8028, 1271],
  ["קצרין", 32.99246, 35.68681, 8012, 4100],
  ["פרדסייה", 32.30595, 34.91051, 7972, 171],
  ["זמר", 32.36510, 35.03496, 7953, 1290],
  ["רמת ישי", 32.70281, 35.16552, 7953, 122],
  ["קריית יערים", 31.80377, 35.10080, 7839, 1137],
  ["שעב", 32.89025, 35.23523, 7790, 538],
  ["צור יצחק", 32.24117, 34.99913, 7780, 1345],
  ["בית דגן", 32.00047, 34.82998, 7727, 466],
  ["קריית ארבע", 31.53547, 35.11826, 7698, 3611],
  ["טובא-זנגרייה", 32.96516, 35.59145, 7173, 962],
  ["בוקעאתא", 33.20163, 35.77869, 6983, 4001],
  ["תל ציון", 31.87955, 35.23859, 6935, 3815],
  ["יאנוח-ג'ת", 32.98067, 35.24497, 6890, 1295],
  ["חורפיש", 33.01763, 35.34650, 6876, 496],
  ["ג'ולס", 32.94221, 35.18339, 6821, 485],
  ["בני עי\"ש", 31.78953, 34.76059, 6579, 1066],
  ["כעביה-טבאש-חג'אג'רה", 32.75001, 35.18529, 6545, 978],
  ["שבלי - אום אל-גנם", 32.68911, 35.40221, 6476, 913],
  ["כפר חב\"ד", 31.99022, 34.85014, 6391, 696],
  ["בית אל", 31.94179, 35.22301, 6359, 3574],
  ["פקיעין (בוקייעה)", 32.97770, 35.32777, 6114, 536],
  ["אל סייד", 31.28536, 34.91385, 6109, 1359],
  ["שילה", 32.05293, 35.30072, 6042, 3641],
  ["טלמון", 31.95439, 35.12494, 6040, 3788],
  ["גבע בנימין", 31.84988, 35.27583, 5900, 3763],
  ["עיילבון", 32.83636, 35.40172, 5849, 530],
  ["מצפה רמון", 30.62290, 34.80162, 5842, 99],
  ["אבו תלול", 31.18416, 34.93031, 5716, 1375],
  ["עמנואל", 32.16244, 35.13838, 5675, 3660],
  ["קיסריה", 32.50429, 34.90822, 5633, 1167],
  ["בית אריה-עופרים", 32.03308, 35.04989, 5627, 3652],
  ["אום בטין", 31.28033, 34.88121, 5572, 1358],
  ["כפר ורדים", 32.99579, 35.26904, 5534, 1263],
  ["עלי זהב", 32.07036, 35.05798, 5474, 3727],
  ["סעוה", 31.25502, 34.97057, 5466, 1360],
  ["כפר אדומים", 31.82692, 35.33804, 5206, 3638],
  ["עלי", 32.07249, 35.26701, 4979, 3765],
  ["בת חפר", 32.33331, 35.01358, 4865, 1319],
  ["תקוע", 31.65022, 35.23014, 4834, 3563],
  ["יבנאל", 32.70849, 35.50345, 4801, 46],
  ["מוקייבלה", 32.51394, 35.29682, 4638, 635],
  ["קדומים", 32.21934, 35.16079, 4564, 3557],
  ["אלקנה", 32.11138, 35.03676, 4493, 3560],
  ["סביון", 32.04684, 34.87867, 4404, 587],
  ["הר אדר", 31.82678, 35.12913, 4340, 3769],
  ["יד בנימין", 31.79777, 34.82221, 4338, 577],
  ["סאג'ור", 32.94223, 35.34352, 4304, 525],
  ["כפר תבור", 32.68704, 35.42045, 4275, 47],
  ["מסעדה", 33.23103, 35.75666, 4205, 4203],
  ["כוכב יעקב", 31.87997, 35.24634, 4093, 3779],
  ["כאוכב אבו אל-היג'א", 32.83058, 35.24870, 4036, 505],
  ["כפר ברא", 32.13108, 34.97071, 3962, 633],
  ["מזרעה", 32.98323, 35.09948, 3922, 517],
  ["סלמה", 32.89466, 35.36372, 3878, 1245],
  ["אליכין", 32.40773, 34.92511, 3856, 41],
  ["עין נקובא", 31.79323, 35.12123, 3849, 521],
  ["עוזייר", 32.79051, 35.32569, 3557, 528],
  ["קצר א-סר", 31.08300, 34.98213, 3551, 1347],
  ["כפר כמא", 32.72178, 35.44038, 3545, 508],
  ["נוקדים", 31.64915, 35.24825, 3498, 3726],
  ["ברכה", 32.19288, 35.26525, 3485, 3710],
  ["פסוטה", 33.04852, 35.30976, 3426, 535],
  ["מעיליא", 33.02729, 35.25725, 3323, 518],
  ["ראש פינה", 32.96810, 35.54253, 3308, 26],
  ["גני מודיעין", 31.92910, 35.01727, 3260, 3823],
  ["ג'ש (גוש חלב)", 33.02254, 35.44563, 3244, 487],
  ["רבבה", 32.11871, 35.12835, 3202, 3795],
  ["מתן", 32.15859, 34.97401, 3145, 1315],
  ["אלון שבות", 31.65488, 35.12610, 3141, 3604],
  ["עפרה", 31.95396, 35.26134, 3110, 3617],
  ["חשמונאים", 31.93142, 35.02374, 3091, 3770],
  ["שייח' דנון", 32.99356, 35.14814, 2997, 658],
  ["מרכז שפירא", 31.69614, 34.70658, 2962, 1098],
  ["סולם", 32.60604, 35.33444, 2933, 526],
  ["נעלה", 31.96327, 35.06358, 2931, 3787],
  ["ביר הדאג'", 31.02622, 34.70182, 2899, 1348],
  ["באר גנים", 31.70033, 34.60889, 2890, 1376],
  ["מצפה יריחו", 31.81616, 35.39434, 2867, 3576],
  ["אבטין", 32.76153, 35.11345, 2837, 652],
  ["אבו קורינאת (יישוב)", 31.14058, 34.96230, 2827, 1342],
  ["כפר מצר", 32.64560, 35.42208, 2816, 512],
  ["ברוכין", 32.08149, 35.09046, 2808, 3744],
  ["כוכב השחר", 31.95984, 35.34924, 2778, 3564],
  ["צור משה", 32.29772, 34.91386, 2769, 276],
  ["יקיר", 32.14903, 35.11183, 2742, 3647],
  ["ע'ג'ר", 33.27070, 35.62340, 2739, 4501],
  ["מבוא חורון", 31.84916, 35.03539, 2659, 3709],
  ["גן נר", 32.53193, 35.33812, 2657, 1274],
  ["ניצן", 31.73994, 34.63169, 2634, 351],
  ["קציר", 32.48609, 35.10333, 2630, 1243],
  ["רומת הייב", 32.77759, 35.30482, 2626, 997],
  ["צופים", 32.19868, 35.01028, 2605, 3791],
  ["אלעזר", 31.66117, 35.14130, 2598, 3618],
  ["אבני חפץ", 32.28522, 35.07296, 2526, 3793],
  ["יצהר", 32.16804, 35.23746, 2525, 3749],
  ["גבעת ברנר", 31.86730, 34.80092, 2518, 147],
  ["נאעורה", 32.61385, 35.39134, 2481, 524],
  ["עין קנייא", 33.23709, 35.73155, 2470, 4502],
  ["אחוזת ברק", 32.64297, 35.33806, 2460, 1330],
  ["נווה דניאל", 31.67798, 35.14343, 2418, 3725],
  ["נופית", 32.75933, 35.14563, 2380, 1284],
  ["אחיעזר", 31.98242, 34.87095, 2335, 797],
  ["כפר האורנים", 31.91971, 35.03703, 2314, 3796],
  ["תפרח", 31.32540, 34.67819, 2307, 709],
  ["בית יצחק-שער חפר", 32.33421, 34.89077, 2299, 326],
  ["פסגות", 31.89872, 35.22495, 2298, 3659],
  ["ניל\"י", 31.96298, 35.04670, 2262, 3655],
  ["מעלה מכמש", 31.87875, 35.30822, 2259, 3651],
  ["מטולה", 33.27861, 35.57707, 2248, 43],
  ["ברקת", 32.01612, 34.94445, 2232, 2038],
  ["שתולים", 31.77387, 34.68358, 2224, 763],
  ["פדואל", 32.06225, 35.05255, 2220, 3768],
  ["טייבה (בעמק)", 32.60424, 35.44497, 2198, 497],
  ["אלון מורה", 32.23429, 35.33218, 2170, 3579],
  ["ברקן", 32.10848, 35.10582, 2170, 3654],
  ["מגדל", 32.83861, 35.50335, 2161, 65],
  ["שמשית", 32.73276, 35.24665, 2155, 1337],
  ["בית חשמונאי", 31.88853, 34.91920, 2154, 1050],
  ["גבעת אבני", 32.77556, 35.43893, 2143, 1293],
  ["נורדייה", 32.31487, 34.89639, 2127, 447],
  ["מכחול", 31.29003, 35.06691, 2105, 1343],
  ["כפר ויתקין", 32.38159, 34.87782, 2094, 190],
  ["מעגן מיכאל", 32.55597, 34.91571, 2092, 694],
  ["בת עין", 31.65822, 35.10092, 2034, 3794],
  ["ניין", 32.63121, 35.34867, 2033, 523],
  ["שער אפרים", 32.28900, 34.99717, 2020, 661],
  ["הושעיה", 32.75850, 35.29162, 2014, 1186],
  ["אבן שמואל", 31.57490, 34.76544, 2007, 400],
  ["לפיד", 31.91737, 35.03263, 2001, 1310],
  ["שעלבים", 31.87009, 34.98292, 1987, 856],
  ["כפר שמריהו", 32.18609, 34.82110, 1981, 267],
  ["חספין", 32.84538, 35.79426, 1956, 4005],
  ["מייסר", 32.44469, 35.04187, 1952, 649],
  ["בני דקלים", 31.51746, 34.92018, 1947, 1368],
  ["יסוד המעלה", 33.05696, 35.60290, 1930, 29],
  ["נוף איילון", 31.86891, 34.98887, 1900, 1333],
  ["נען", 31.88392, 34.85774, 1834, 158],
  ["צנדלה", 32.52263, 35.32331, 1817, 636],
  ["חיננית", 32.48139, 35.16744, 1793, 3643],
  ["אחיטוב", 32.38778, 34.99056, 1782, 850],
  ["גבעת אלה", 32.72148, 35.24540, 1780, 1288],
  ["עראמשה", 33.08864, 35.22569, 1773, 1246],
  ["עדי", 32.78222, 35.17387, 1772, 1199],
  ["כרמי יוסף", 31.84768, 34.92029, 1761, 1264],
  ["איתמר", 32.17355, 35.30790, 1759, 3762],
  ["חמאם", 32.82985, 35.48998, 1759, 993],
  ["מעלה אפרים", 32.07125, 35.40401, 1748, 3608],
  ["מאור", 32.42452, 35.00606, 1736, 2055],
  ["קדרון", 31.81544, 34.79600, 1732, 615],
  ["טמרה (יזרעאל)", 32.63452, 35.40390, 1727, 547],
  ["חצב", 31.78109, 34.76970, 1724, 700],
  ["אלומה", 31.65153, 34.74373, 1706, 1145],
  ["רמות השבים", 32.16653, 34.88468, 1689, 206],
  ["עין ורד", 32.26467, 34.93182, 1672, 157],
  ["עזריקם", 31.75083, 34.69707, 1671, 817],
  ["גילת", 31.32798, 34.65203, 1666, 736],
  ["מוצא עילית", 31.79381, 35.15762, 1662, 208],
  ["עין יהב", 30.65812, 35.23747, 1653, 806],
  ["כמאנה", 32.91321, 35.35080, 1635, 1331],
  ["הר גילה", 31.72331, 35.16837, 1634, 3603],
  ["פורייה - נווה עובד", 32.74416, 35.53732, 1631, 1105],
  ["בית אלעזרי", 31.84405, 34.80293, 1629, 562],
  ["כפר הס", 32.24629, 34.93387, 1624, 187],
  ["מורשת", 32.82601, 35.23288, 1610, 1178],
  ["כפר תפוח", 32.11871, 35.25009, 1605, 3572],
  ["סוסיה", 31.39210, 35.11352, 1605, 3756],
  ["דולב", 31.92646, 35.13320, 1593, 3747],
  ["פורת", 32.27632, 34.95027, 1587, 767],
  ["נהלל", 32.69038, 35.19653, 1573, 80],
  ["מדרשת בן גוריון", 30.85315, 34.78145, 1571, 1140],
  ["שדה עוזיהו", 31.75649, 34.67775, 1556, 739],
  ["מנשית זבדה", 32.70657, 35.19361, 1550, 994],
  ["קדר", 31.75300, 35.30924, 1548, 3781],
  ["בית זית", 31.78211, 35.16187, 1541, 710],
  ["נחלים", 32.05907, 34.91230, 1519, 449],
  ["שפיים", 32.21744, 34.82487, 1514, 232],
  ["אספר", 31.58602, 35.18741, 1513, 3754],
  ["גשר הזיו", 33.03859, 35.11166, 1513, 574],
  ["יגור", 32.74204, 35.07720, 1508, 96],
  ["עין שריד", 32.27374, 34.93543, 1504, 880],
  ["עין הבשור", 31.28145, 34.44245, 1501, 1240],
  ["נווה צוף", 32.00642, 35.12677, 1500, 3573],
  ["באר טוביה", 31.73458, 34.72375, 1495, 155],
  ["יקנעם (מושבה)", 32.65473, 35.11494, 1487, 241],
  ["חמ\"ד", 32.01902, 34.83937, 1484, 801],
  ["מצליח", 31.90636, 34.87324, 1477, 757],
  ["עלמון", 31.82984, 35.29464, 1474, 3715],
  ["סלעית", 32.24245, 35.05060, 1471, 3567],
  ["בית השיטה", 32.55193, 35.43981, 1467, 242],
  ["נופים", 32.15504, 35.10170, 1462, 3790],
  ["נווה", 31.16241, 34.33394, 1450, 1366],
  ["רומאנה", 32.78797, 35.31081, 1446, 539],
  ["תמרת", 32.70349, 35.22522, 1443, 1244],
  ["פורייה עילית", 32.73048, 35.54659, 1442, 1313],
  ["כפר סירקין", 32.07693, 34.92420, 1439, 249],
  ["בית חורון", 31.87810, 35.12668, 1434, 3575],
  ["אורה", 31.75400, 35.15304, 1428, 780],
  ["נחושה", 31.62740, 34.95233, 1421, 59],
  ["עין ראפה", 31.79099, 35.11506, 1417, 514],
  ["משמר דוד", 31.82283, 34.90061, 1414, 563],
  ["בית חלקיה", 31.79229, 34.81166, 1403, 2033],
  ["מגל", 32.38573, 35.03325, 1403, 375],
  ["שורש", 31.79725, 35.06526, 1400, 456],
  ["אחיסמך", 31.93560, 34.90795, 1399, 804],
  ["לכיש", 31.56122, 34.84210, 1398, 24],
  ["זכריה", 31.70982, 34.94502, 1392, 799],
  ["כפר ראש הנקרה", 33.08615, 35.11517, 1383, 579],
  ["עולש", 32.33219, 34.98566, 1382, 737],
  ["באר אורה", 29.71075, 34.98674, 1378, 21],
  ["נווה ימין", 32.17133, 34.94014, 1377, 686],
  ["רמות מנשה", 32.59746, 35.05794, 1371, 445],
  ["משמרות", 32.48665, 34.98432, 1364, 213],
  ["בני ראם", 31.77095, 34.79150, 1359, 588],
  ["גבעות בר", 31.35656, 34.75650, 1351, 1344],
  ["עזריה", 31.89043, 34.90957, 1351, 711],
  ["כפר הרא\"ה", 32.39062, 34.91182, 1349, 217],
  ["בני דרור", 32.26219, 34.89908, 1346, 386],
  ["כפר מנחם", 31.72959, 34.83286, 1342, 274],
  ["מעלה עמוס", 31.59929, 35.22602, 1340, 3653],
  ["תל עדשים", 32.65634, 35.30289, 1335, 103],
  ["יפעת", 32.67681, 35.22479, 1334, 134],
  ["מבועים", 31.44983, 34.65449, 1334, 1080],
  ["ביצרון", 31.79605, 34.72965, 1330, 234],
  ["מעגלים", 31.39676, 34.59860, 1322, 1082],
  ["טל שחר", 31.80515, 34.90268, 1321, 462],
  ["שבי ציון", 32.98178, 35.08405, 1321, 282],
  ["רשפון", 32.20054, 34.82432, 1320, 247],
  ["חירות", 32.24028, 34.91465, 1319, 162],
  ["שדה ורבורג", 32.20755, 34.90306, 1318, 284],
  ["טל-אל", 32.92597, 35.17837, 1316, 1181],
  ["מכמורת", 32.40629, 34.87337, 1314, 382],
  ["מרחביה (קיבוץ)", 32.60627, 35.30719, 1312, 66],
  ["ברכיה", 31.66928, 34.62539, 1307, 746],
  ["חולדה", 31.83139, 34.88255, 1306, 160],
  ["נהורה", 31.62298, 34.70558, 1298, 309],
  ["חצבה", 30.76843, 35.27988, 1297, 13],
  ["ניצני עוז", 32.30590, 35.00411, 1288, 851],
  ["צרופה", 32.64849, 34.94743, 1288, 612],
  ["גבעת חיים (איחוד)", 32.39941, 34.93216, 1283, 2018],
  ["חוסן", 32.99779, 35.29671, 1283, 662],
  ["עין יעקב", 33.00974, 35.22997, 1278, 813],
  ["נס הרים", 31.74496, 35.05737, 1273, 825],
  ["גבעת יערים", 31.78686, 35.09194, 1271, 787],
  ["אביחיל", 32.35084, 34.87119, 1270, 175],
  ["גבעת חיים (מאוחד)", 32.39144, 34.93077, 1265, 173],
  ["גבעתי", 31.73299, 34.68055, 1261, 793],
  ["עין איילה", 32.62916, 34.94619, 1260, 687],
  ["עצמון שגב", 32.86576, 35.25177, 1260, 917],
  ["רחלים", 32.10240, 35.25698, 1260, 3822],
  ["אום אל-קוטוף", 32.46919, 35.05638, 1259, 2024],
  ["טירת יהודה", 32.01373, 34.93378, 1256, 663],
  ["ינון", 31.74257, 34.78149, 1255, 2011],
  ["נתיב העשרה", 31.57215, 34.53960, 1254, 1242],
  ["ניר גלים", 31.82415, 34.68206, 1251, 720],
  ["יד רמב\"ם", 31.90013, 34.90066, 1246, 64],
  ["רמת הכובש", 32.21731, 34.93796, 1246, 184],
  ["בני יהודה", 32.79823, 35.68940, 1244, 4015],
  ["משמר העמק", 32.61023, 35.14239, 1244, 130],
  ["אילון", 33.06328, 35.21685, 1243, 294],
  ["ערוגות", 31.73417, 34.77245, 1242, 593],
  ["רינתיה", 32.04447, 34.92831, 1235, 616],
  ["הגושרים", 33.22072, 35.62366, 1232, 356],
  ["אלישמע", 32.15264, 34.92848, 1229, 841],
  ["בית רימון", 32.78203, 35.32813, 1229, 1162],
  ["ענב", 32.28424, 35.12593, 1228, 3712],
  ["גן שמואל", 32.45218, 34.95056, 1226, 72],
  ["כפר יחזקאל", 32.56714, 35.35970, 1224, 85],
  ["כפר יהושע", 32.68265, 35.15239, 1220, 140],
  ["בית אלפא", 32.51689, 35.43148, 1216, 95],
  ["מגדים", 32.72976, 34.95908, 1215, 689],
  ["רשפים", 32.48010, 35.47657, 1213, 437],
  ["מולדת", 32.58635, 35.44047, 1211, 269],
  ["כפר ביל\"ו", 31.87279, 34.82562, 1210, 177],
  ["נווה ירק", 32.13303, 34.92433, 1210, 858],
  ["כפר עציון", 31.64947, 35.11569, 1209, 3488],
  ["שדה נחום", 32.52777, 35.48142, 1204, 259],
  ["הזורעים", 32.74600, 35.50243, 1202, 307],
  ["גילון", 32.90297, 35.23704, 1201, 1204],
  ["מנחמיה", 32.66605, 35.55501, 1200, 48],
  ["כפר ורבורג", 31.71915, 34.72666, 1199, 320],
  ["דביר", 31.41350, 34.82283, 1197, 849],
  ["מצובה", 33.06281, 35.15681, 1196, 325],
  ["נוב", 32.83277, 35.78265, 1192, 4304],
  ["זיתן", 31.97571, 34.89045, 1191, 788],
  ["ריחאנייה", 33.04941, 35.48741, 1188, 540],
  ["ירחיב", 32.15320, 34.96846, 1182, 718],
  ["בארותיים", 32.32176, 34.98331, 1180, 697],
  ["יובלים", 32.87861, 35.27019, 1180, 1226],
  ["גבע כרמל", 32.66258, 34.95477, 1179, 683],
  ["יסודות", 31.81529, 34.86523, 1179, 440],
  ["צופית", 32.19287, 34.92106, 1178, 198],
  ["נבטים", 31.22316, 34.88160, 1174, 396],
  ["בר יוחאי", 32.99732, 35.44905, 1173, 1191],
  ["גבעון החדשה", 31.84801, 35.15825, 1171, 3644],
  ["אודים", 32.26538, 34.84735, 1167, 446],
  ["בית עזרא", 31.73738, 34.65542, 1167, 756],
  ["עין דור", 32.65738, 35.41623, 1165, 436],
  ["רמת יוחנן", 32.79349, 35.12215, 1162, 178],
  ["שדות ים", 32.49150, 34.89280, 1161, 327],
  ["ראש צורים", 31.66794, 35.12511, 1157, 3602],
  ["מבוא ביתר", 31.72247, 35.10656, 1153, 771],
  ["בני נצרים", 31.14102, 34.31475, 1152, 1363],
  ["חדיד", 31.96892, 34.93183, 1152, 618],
  ["אחיהוד", 32.90779, 35.17310, 1150, 785],
  ["בני ציון", 32.21897, 34.86842, 1150, 418],
  ["גמזו", 31.92786, 34.94095, 1150, 745],
  ["משמר הנגב", 31.36351, 34.71701, 1149, 395],
  ["שדה נחמיה", 33.18738, 35.62365, 1147, 329],
  ["בית הגדי", 31.42532, 34.60645, 1146, 723],
  ["פארן", 30.36319, 35.15462, 1146, 1151],
  ["שקד", 32.47332, 35.16871, 1146, 3649],
  ["חגור", 32.13730, 34.94708, 1145, 717],
  ["ישרש", 31.91520, 34.84809, 1145, 828],
  ["אפיקים", 32.68110, 35.57803, 1140, 176],
  ["יגל", 31.98854, 34.87913, 1139, 798],
  ["בית עריף", 31.99593, 34.93444, 1138, 604],
  ["אירוס", 31.92907, 34.77672, 1135, 1336],
  ["בורגתה", 32.32507, 34.96260, 1129, 698],
  ["רמת השופט", 32.61072, 35.09411, 1129, 335],
  ["שובה", 31.45170, 34.54413, 1129, 761],
  ["טירת צבי", 32.42074, 35.52863, 1126, 268],
  ["בארי", 31.42385, 34.49086, 1125, 399],
  ["סתרייה", 31.89020, 34.84459, 1125, 610],
  ["גבת", 32.67479, 35.21248, 1124, 133],
  ["תראבין א-צאנע (יישוב)", 31.34417, 34.74006, 1124, 1346],
  ["היוגב", 32.61184, 35.20481, 1121, 684],
  ["קבוצת יבנה", 31.81543, 34.71960, 1120, 334],
  ["מתתיהו", 31.92972, 35.03311, 1119, 3648],
  ["ניר צבי", 31.95247, 34.86297, 1116, 331],
  ["פטיש", 31.32739, 34.56004, 1116, 749],
  ["מזור", 32.05153, 34.92547, 1115, 606],
  ["נצר סרני", 31.92317, 34.82358, 1115, 435],
  ["צלפון", 31.80474, 34.93083, 1115, 796],
  ["כוכב מיכאל", 31.62949, 34.66886, 1114, 824],
  ["אשתאול", 31.78113, 35.00914, 1112, 740],
  ["בני דרום", 31.82042, 34.69154, 1109, 592],
  ["בית הלל", 33.20843, 35.60577, 1107, 322],
  ["בית יהושע", 32.26011, 34.86558, 1107, 288],
  ["איילת השחר", 33.02368, 35.57618, 1105, 77],
  ["סעד", 31.47068, 34.53445, 1100, 419],
  ["אדרת", 31.66044, 34.99489, 1094, 1123],
  ["גאליה", 31.88505, 34.76548, 1094, 853],
  ["מעונה", 33.01630, 35.26090, 1091, 570],
  ["טנא", 31.37464, 34.95664, 1089, 3743],
  ["מצפה אבי\"ב", 32.83679, 35.20033, 1088, 1222],
  ["יציץ", 31.86310, 34.86038, 1086, 759],
  ["בוסתן הגליל", 32.95134, 35.08214, 1085, 559],
  ["ברור חיל", 31.55787, 34.64673, 1084, 428],
  ["שדה יעקב", 32.69823, 35.14137, 1082, 142],
  ["צפרייה", 32.00296, 34.85649, 1081, 594],
  ["אבני איתן", 32.82322, 35.76520, 1079, 4011],
  ["שבי שומרון", 32.26362, 35.18515, 1077, 3571],
  ["אמונים", 31.74366, 34.67573, 1076, 772],
  ["שפיר", 31.69717, 34.72835, 1074, 692],
  ["בית נחמיה", 31.97664, 34.95499, 1073, 784],
  ["חבר", 32.54781, 35.26413, 1073, 1110],
  ["גני טל", 31.78846, 34.79206, 1070, 1371],
  ["מבטחים", 31.24040, 34.40787, 1070, 829],
  ["משמר השבעה", 32.00963, 34.82353, 1070, 729],
  ["כברי", 33.02140, 35.14902, 1067, 576],
  ["בחן", 32.35209, 35.02005, 1062, 2043],
  ["שמעה", 31.38773, 35.01277, 1060, 3784],
  ["אלון הגליל", 32.75686, 35.21932, 1058, 1182],
  ["רגבה", 32.97778, 35.09961, 1057, 390],
  ["גינתון", 31.96285, 34.91396, 1055, 863],
  ["תל יצחק", 32.25302, 34.86806, 1055, 287],
  ["נווה אילן", 31.80828, 35.08093, 1052, 405],
  ["שובל", 31.41449, 34.74384, 1052, 394],
  ["אור הנר", 31.55711, 34.59989, 1048, 67],
  ["בית קמה", 31.44853, 34.76108, 1044, 598],
  ["עזריאל", 32.26242, 34.97058, 1044, 837],
  ["מזרע", 32.65093, 35.28639, 1042, 104],
  ["שדי חמד", 32.15951, 34.94319, 1042, 2015],
  ["דפנה", 33.22995, 35.63852, 1038, 302],
  ["הזורע", 32.64401, 35.11944, 1031, 250],
  ["משמרת", 32.22811, 34.92017, 1029, 425],
  ["בן זכאי", 31.85654, 34.72881, 1025, 760],
  ["גבעת כ\"ח", 32.03142, 34.93577, 1023, 802],
  ["דלתון", 33.01688, 35.48909, 1019, 431],
  ["נירית", 32.14685, 34.98501, 1017, 1236],
  ["יד מרדכי", 31.58896, 34.55842, 1014, 358],
  ["עתניאל", 31.43933, 35.02921, 1014, 3748],
  ["עשרת", 31.82464, 34.74726, 1009, 591],
  ["חנתון", 32.78383, 35.24496, 1008, 1257],
  ["שריד", 32.66328, 35.22520, 1007, 126],
  ["מעלה לבונה", 32.05489, 35.24009, 1006, 3752],
  ["שדה אליעזר", 33.04538, 35.56346, 1005, 861],
  ["להבות חביבה", 32.39499, 35.00926, 1004, 715],
  ["ציפורי", 32.74544, 35.27851, 1001, 613],
  ["אשחר", 32.88583, 35.30070, 1000, 1188],
  ["זיקים", 31.60963, 34.52175, 997, 584],
  ["יתד", 31.20635, 34.32694, 996, 1227],
  ["מסלול", 31.32439, 34.58945, 993, 748],
  ["חוסנייה", 32.90025, 35.32034, 992, 1332],
  ["נטע", 31.47795, 34.92610, 991, 1369],
  ["גן יאשיה", 32.35055, 34.99377, 990, 734],
  ["חצרים", 31.24010, 34.71344, 990, 397],
  ["פדיה", 31.85800, 34.88259, 989, 838],
  ["בית גמליאל", 31.85670, 34.76128, 988, 571],
  ["לוחמי הגיטאות", 32.96373, 35.09800, 988, 595],
  ["כרמי צור", 31.60881, 35.10036, 987, 3766],
  ["כפר נטר", 32.27539, 34.87158, 986, 316],
  ["כפר שמואל", 31.89015, 34.93232, 983, 743],
  ["שריגים (לי-און)", 31.67764, 34.93497, 983, 1114],
  ["תלמי יחיאל", 31.75327, 34.76280, 982, 727],
  ["מעברות", 32.36364, 34.90491, 981, 197],
  ["בארות יצחק", 32.04080, 34.91041, 979, 450],
  ["קשת", 32.97984, 35.80847, 979, 4006],
  ["בקוע", 31.82879, 34.92570, 977, 864],
  ["יודפת", 32.83761, 35.27191, 976, 1112],
  ["נווה מיכאל", 31.67294, 35.00618, 975, 1071],
  ["תנובות", 32.30556, 34.96264, 974, 2002],
  ["עברון", 32.99187, 35.10049, 973, 376],
  ["מצפה נטופה", 32.80253, 35.38577, 970, 1190],
  ["מגידו", 32.58041, 35.17968, 969, 586],
  ["עין השופט", 32.59588, 35.10035, 966, 270],
  ["בצרה", 32.21289, 34.87813, 965, 389],
  ["הסוללים", 32.75067, 35.23758, 965, 677],
  ["כפר הנגיד", 31.88765, 34.74956, 964, 582],
  ["כפר עזה", 31.48360, 34.53191, 964, 845],
  ["נווה זיו", 33.02741, 35.18263, 964, 1314],
  ["בית חירות", 32.37907, 34.86759, 963, 877],
  ["חצור-אשדוד", 31.77259, 34.72033, 963, 406],
  ["משמר הירדן", 33.00507, 35.59995, 962, 732],
  ["אשדות יעקב (איחוד)", 32.65814, 35.58029, 960, 199],
  ["גאולים", 32.29796, 34.94546, 959, 379],
  ["פתחיה", 31.86735, 34.88571, 959, 839],
  ["געש", 32.22911, 34.82474, 957, 842],
  ["בירייה", 32.97793, 35.50019, 956, 368],
  ["עין אל-אסד", 32.94036, 35.39943, 956, 546],
  ["אומן", 32.56337, 35.24255, 955, 1108],
  ["חיבת ציון", 32.39739, 34.91239, 955, 219],
  ["גנות הדר", 32.32067, 34.90057, 954, 549],
  ["כפר מונש", 32.34744, 34.91613, 953, 387],
  ["יד חנה", 32.32608, 35.00618, 952, 758],
  ["תלמי אלעזר", 32.44527, 34.97743, 952, 2003],
  ["מענית", 32.45670, 35.02732, 950, 344],
  ["מפלסים", 31.50204, 34.56138, 949, 668],
  ["ניצני סיני", 30.90462, 34.39731, 949, 1280],
  ["אביגדור", 31.71023, 34.74320, 947, 819],
  ["עמקה", 32.97917, 35.16191, 947, 708],
  ["משען", 31.65720, 34.62370, 946, 791],
  ["גת (קיבוץ)", 31.62779, 34.79470, 945, 340],
  ["עמינדב", 31.75164, 35.14167, 945, 779],
  ["אליקים", 32.63214, 35.06730, 943, 682],
  ["שומרייה", 31.43221, 34.88372, 943, 1265],
  ["מסילת ציון", 31.80210, 35.01091, 941, 742],
  ["החותרים", 32.75244, 34.95679, 940, 434],
  ["רקפת", 32.85494, 35.26486, 939, 1228],
  ["ישעי", 31.75153, 34.96559, 938, 805],
  ["איתן", 31.57232, 34.74820, 936, 37],
  ["צרעה", 31.76289, 34.96913, 934, 567],
  ["כפר מימון", 31.43218, 34.53590, 932, 1095],
  ["המעפיל", 32.37834, 34.98270, 929, 377],
  ["כפר בלום", 33.17330, 35.60874, 929, 357],
  ["כליל", 32.98057, 35.19729, 924, 1183],
  ["תלמים", 31.56435, 34.67193, 924, 814],
  ["עינת", 32.08285, 34.93755, 923, 871],
  ["קריית נטפים", 32.11667, 35.11265, 923, 3746],
  ["אביעזר", 31.68179, 35.01679, 921, 1070],
  ["בני עטרות", 32.02395, 34.91418, 921, 448],
  ["מעלה גלבוע", 32.47695, 35.41875, 921, 1127],
  ["כרם מהר\"ל", 32.64604, 34.99048, 920, 580],
  ["עין שמר", 32.46370, 35.00713, 920, 139],
  ["אשדות יעקב (מאוחד)", 32.66182, 35.58349, 919, 188],
  ["תרום", 31.78299, 34.98173, 919, 778],
  ["מגשימים", 32.04658, 34.89900, 916, 722],
  ["מגן שאול", 32.52123, 35.30760, 915, 1155],
  ["רבדים", 31.77381, 34.81590, 915, 564],
  ["כפר חושן", 33.01217, 35.43888, 914, 609],
  ["גן השומרון", 32.46264, 34.99840, 912, 225],
  ["אלוני אבא", 32.72933, 35.17045, 911, 429],
  ["מצפה אילן", 32.46255, 35.06936, 911, 1370],
  ["עוצם", 31.63682, 34.70380, 910, 32],
  ["חניאל", 32.33307, 34.94891, 909, 807],
  ["סער", 33.02969, 35.10874, 907, 454],
  ["קורנית", 32.84369, 35.25263, 907, 1179],
  ["עלמה", 33.05118, 35.49985, 906, 688],
  ["תקומה", 31.45092, 34.57933, 906, 665],
  ["מעלה החמישה", 31.81773, 35.11054, 900, 286],
  ["לימן", 33.05992, 35.11279, 896, 674],
  ["יונתן", 32.93801, 35.79438, 895, 4007],
  ["בטחה", 31.33427, 34.63253, 894, 762],
  ["בניה", 31.84376, 34.75301, 894, 685],
  ["יערה", 33.06718, 35.18555, 894, 795],
  ["מעגן", 32.70661, 35.60029, 893, 678],
  ["עין החורש", 32.38596, 34.93967, 892, 167],
  ["בית שקמה", 31.63790, 34.60772, 891, 747],
  ["זרחיה", 31.68157, 34.74560, 891, 818],
  ["צופר", 30.56033, 35.18066, 891, 1150],
  ["בית העמק", 32.97148, 35.14409, 890, 572],
  ["רם-און", 32.52690, 35.25971, 890, 1069],
  ["שחר", 31.61972, 34.72551, 889, 7],
  ["דורות", 31.50672, 34.64506, 887, 336],
  ["חופית", 32.38499, 34.87412, 887, 115],
  ["יובל", 33.24668, 35.59795, 886, 2009],
  ["חד-נס", 32.92740, 35.64237, 885, 4026],
  ["דלייה", 32.58968, 35.07490, 883, 300],
  ["לבון", 32.94263, 35.28680, 883, 1207],
  ["לוזית", 31.68694, 34.88653, 881, 52],
  ["עין צורים", 31.69563, 34.71921, 881, 622],
  ["ערב אל נעים", 32.88811, 35.29025, 881, 1335],
  ["נגבה", 31.66155, 34.68247, 880, 315],
  ["מטע", 31.71795, 35.06208, 878, 822],
  ["בית זרע", 32.68891, 35.57341, 877, 143],
  ["ניר דוד (תל עמל)", 32.50376, 35.45585, 877, 256],
  ["צורית", 32.90260, 35.25146, 877, 1221],
  ["מעש", 32.06464, 34.88972, 874, 230],
  ["ניר ישראל", 31.68734, 34.63648, 874, 699],
  ["עין המפרץ", 32.90314, 35.09652, 873, 289],
  ["רמות", 32.84969, 35.66670, 872, 4702],
  ["סנסנה", 31.36255, 34.90210, 871, 3777],
  ["ינוב", 32.30654, 34.94945, 869, 753],
  ["מעיין ברוך", 33.23980, 35.60722, 868, 416],
  ["רביבים", 31.04397, 34.72178, 867, 354],
  ["להבות הבשן", 33.14149, 35.64734, 865, 380],
  ["עין חרוד (מאוחד)", 32.55837, 35.39155, 860, 82],
  ["מחניים", 32.98906, 35.57012, 859, 308],
  ["מירב", 32.45283, 35.42212, 858, 1282],
  ["הדר עם", 32.34904, 34.90118, 853, 191],
  ["יסעור", 32.90113, 35.16539, 853, 575],
  ["עידן", 30.80660, 35.30045, 853, 1175],
  ["חגי", 31.49303, 35.07985, 851, 3764],
  ["יחיעם", 32.99759, 35.22004, 851, 409],
  ["כפר מסריק", 32.89035, 35.10026, 851, 297],
  ["זבדיאל", 31.65894, 34.76012, 850, 815],
  ["זמרת", 31.44804, 34.55258, 850, 1065],
  ["כפר טרומן", 31.98049, 34.92423, 850, 673],
  ["בן שמן (מושב)", 31.95266, 34.92285, 849, 2013],
  ["פלמחים", 31.93357, 34.70625, 848, 597],
  ["אליאב", 31.52863, 34.93039, 846, 1365],
  ["חרב לאת", 32.40186, 34.91678, 844, 422],
  ["הרדוף", 32.76369, 35.17310, 843, 1249],
  ["גזית", 32.63916, 35.44699, 841, 457],
  ["עמיעוז", 31.24846, 34.41295, 840, 318],
  ["דן", 33.24014, 35.65281, 839, 303],
  ["שילת", 31.91883, 35.01890, 838, 1165],
  ["בית הלוי", 32.35370, 34.93139, 837, 373],
  ["חפצי-בה", 32.51905, 35.42398, 837, 90],
  ["כפר הרי\"ף", 31.74546, 34.79289, 837, 888],
  ["מנוף", 32.85329, 35.23660, 834, 1174],
  ["כרמי קטיף", 31.53759, 34.91188, 833, 1374],
  ["שאר ישוב", 33.22647, 35.64649, 833, 324],
  ["מדרך עוז", 32.59507, 35.15863, 832, 2029],
  ["שער העמקים", 32.72308, 35.11270, 832, 237],
  ["העוגן", 32.36221, 34.92402, 828, 423],
  ["גינוסר", 32.84754, 35.52325, 825, 262],
  ["כפר הנשיא", 32.97474, 35.60344, 825, 443],
  ["הודייה", 31.67492, 34.64079, 824, 726],
  ["יטבתה", 29.89552, 35.05929, 824, 866],
  ["שמיר", 33.16669, 35.65998, 824, 366],
  ["בית לחם הגלילית", 32.73508, 35.19102, 823, 430],
  ["בית חנניה", 32.52804, 34.92574, 821, 800],
  ["כפר בן נון", 31.86177, 34.94732, 821, 2010],
  ["כפר ברוך", 32.64595, 35.19090, 820, 132],
  ["שדמות דבורה", 32.69628, 35.43604, 820, 306],
  ["כפר אוריה", 31.79261, 34.94732, 817, 364],
  ["מרום גולן", 33.13311, 35.77583, 817, 4101],
  ["רתמים", 31.05355, 34.68928, 817, 1260],
  ["כנרת (קבוצה)", 32.71355, 35.56160, 816, 57],
  ["תדהר", 31.37919, 34.62735, 816, 2061],
  ["יכיני", 31.48277, 34.59968, 815, 811],
  ["רמת מגשימים", 32.84478, 35.80794, 815, 4701],
  ["מעיין צבי", 32.56817, 34.94065, 810, 290],
  ["אליפלט", 32.94791, 35.54733, 809, 730],
  ["יושיביה", 31.44377, 34.60920, 809, 803],
  ["כפר ידידיה", 32.34563, 34.89841, 809, 233],
  ["גבעת יואב", 32.79906, 35.68171, 804, 4021],
  ["ניר בנים", 31.67180, 34.75489, 804, 553],
  ["עין העמק", 32.62878, 35.08479, 803, 367],
  ["אומץ", 32.37068, 34.99426, 802, 680],
  ["חוקוק", 32.88061, 35.49529, 802, 374],
  ["ניצנים", 31.71747, 34.63409, 802, 359],
  ["כפר גלעדי", 33.24266, 35.57445, 798, 76],
  ["נחליאל", 31.97439, 35.13930, 798, 3767],
  ["עין כרמל", 32.67728, 34.95279, 797, 426],
  ["שדה דוד", 31.57619, 34.68403, 796, 36],
  ["ראס עלי", 32.77228, 35.15470, 795, 990],
  ["שדה אליהו", 32.44041, 35.51368, 795, 304],
  ["יעד", 32.87931, 35.24240, 794, 1138],
  ["כפר אחים", 31.74463, 34.75697, 794, 690],
  ["מנוחה", 31.65772, 34.77647, 794, 2030],
  ["שדה צבי", 31.44883, 34.71224, 794, 2049],
  ["חניתה", 33.08839, 35.17537, 793, 280],
  ["פעמי תש\"ז", 31.43913, 34.69280, 793, 2059],
  ["בית יתיר", 31.36464, 35.11260, 792, 3745],
  ["כפר חסידים א'", 32.75051, 35.09274, 791, 112],
  ["יקום", 32.24889, 34.84203, 790, 417],
  ["מגדלים", 32.09060, 35.34244, 790, 3751],
  ["מירון", 32.98738, 35.43982, 790, 607],
  ["רמת צבי", 32.59152, 35.41389, 790, 339],
  ["מחולה", 32.36576, 35.51473, 789, 3599],
  ["שדה אילן", 32.74863, 35.42333, 789, 721],
  ["ישע", 31.24755, 34.40255, 785, 916],
  ["רנן", 31.33801, 34.60126, 785, 789],
  ["אשלים", 30.96453, 34.70001, 784, 1152],
  ["אלונים", 32.71998, 35.14529, 783, 285],
  ["אמירים", 32.93719, 35.45154, 780, 1064],
  ["אביאל", 32.53204, 34.99324, 779, 679],
  ["כפר קיש", 32.66702, 35.44908, 779, 388],
  ["מבוא דותן", 32.42084, 35.17473, 777, 3569],
  ["בן עמי", 33.00556, 35.12358, 776, 712],
  ["כפר חנניה", 32.91500, 35.42330, 776, 1297],
  ["נווה מבטח", 31.80538, 34.74115, 776, 827],
  ["גני יוחנן", 31.85810, 34.83828, 775, 862],
  ["כפר אביב", 31.83129, 34.72101, 774, 857],
  ["נוגה", 31.62442, 34.69475, 774, 55],
  ["גיאה", 31.62775, 34.60335, 772, 706],
  ["חגלה", 32.38703, 34.92624, 772, 205],
  ["חולתה", 33.05160, 35.60988, 772, 253],
  ["שדה יצחק", 32.40513, 34.99339, 772, 2008],
  ["שדמות מחולה", 32.34698, 35.53359, 771, 3578],
  ["נטור", 32.85315, 35.75312, 770, 4014],
  ["רוחמה", 31.49799, 34.70613, 770, 362],
  ["מעון", 31.41371, 35.16385, 769, 3657],
  ["שוקדה", 31.42200, 34.52471, 769, 415],
  ["משגב דב", 31.82001, 34.73932, 768, 765],
  ["דגניה ב'", 32.70031, 35.57510, 765, 79],
  ["ארבל", 32.81244, 35.48392, 764, 701],
  ["ח'ואלד", 32.77027, 35.13667, 762, 1321],
  ["בר גיורא", 31.72977, 35.07233, 758, 823],
  ["עמיר", 33.17818, 35.62025, 758, 319],
  ["מישר", 31.81916, 34.75395, 756, 731],
  ["אפק", 32.83854, 35.12798, 751, 313],
  ["חרוצים", 32.22763, 34.86487, 751, 1024],
  ["עמיקם", 32.56314, 35.02088, 751, 773],
  ["גיניגר", 32.66401, 35.25722, 750, 92],
  ["שניר", 33.24222, 35.67798, 750, 1132],
  ["עין הנצי\"ב", 32.47064, 35.50102, 749, 383],
  ["פקיעין חדשה", 32.98395, 35.32256, 749, 281],
  ["גבעת השלושה", 32.09842, 34.92159, 742, 870],
  ["נאות גולן", 32.78643, 35.69111, 742, 4551],
  ["אשבול", 31.44754, 34.66601, 736, 71],
  ["מעלה גמלא", 32.88939, 35.68419, 734, 4008],
  ["מרחביה (מושב)", 32.60381, 35.31641, 734, 97],
  ["קדמת צבי", 33.02999, 35.69767, 734, 4025],
  ["געתון", 33.00641, 35.21522, 733, 463],
  ["נחלה", 31.65820, 34.79463, 733, 2045],
  ["ניר עם", 31.51966, 34.57977, 733, 348],
  ["כרמייה", 31.60515, 34.54196, 731, 768],
  ["משואות יצחק", 31.70270, 34.68939, 731, 620],
  ["ניר עקיבא", 31.46987, 34.64660, 728, 2048],
  ["כפר זיתים", 32.81188, 35.46345, 727, 786],
  ["שמרת", 32.95165, 35.09457, 727, 432],
  ["גברעם", 31.59149, 34.61218, 725, 342],
  ["כפר החורש", 32.70092, 35.27301, 723, 192],
  ["כפר יעבץ", 32.27456, 34.96550, 721, 170],
  ["בית קשת", 32.71862, 35.39406, 720, 365],
  ["כפר סאלד", 33.19563, 35.65802, 720, 345],
  ["נטעים", 31.94511, 34.77578, 720, 174],
  ["אבן ספיר", 31.76282, 35.13461, 719, 783],
  ["גבעת ישעיהו", 31.67114, 34.94548, 719, 919],
  ["עין גדי", 31.45264, 35.38470, 719, 2042],
  ["נחשולים", 32.61354, 34.92081, 717, 433],
  ["עטרת", 32.00069, 35.17707, 716, 3658],
  ["רמת דוד", 32.67823, 35.20178, 716, 135],
  ["אוהד", 31.23718, 34.43139, 714, 1046],
  ["שכניה", 32.84892, 35.24682, 710, 1160],
  ["ניר ח\"ן", 31.60875, 34.71465, 708, 11],
  ["רווחה", 31.64939, 34.73339, 708, 2051],
  ["תלמי ביל\"ו", 31.43780, 34.64514, 708, 2050],
  ["חפץ חיים", 31.78946, 34.80002, 707, 363],
  ["שבי דרום", 31.46588, 34.63914, 707, 1377],
  ["נאות מרדכי", 33.16002, 35.59679, 706, 408],
  ["אור הגנוז", 33.00535, 35.44699, 705, 1294],
  ["כרם בן זמרה", 33.03814, 35.46723, 705, 664],
  ["גבים", 31.50689, 34.59654, 703, 424],
  ["תימורים", 31.71549, 34.75861, 703, 163],
  ["לוטם", 32.88302, 35.35734, 702, 1171],
  ["בית שערים", 32.69662, 35.17824, 700, 248],
  ["ארז", 31.56022, 34.56651, 699, 714],
  ["כמון", 32.91245, 35.35994, 699, 1201],
  ["נופך", 32.04343, 34.92077, 697, 257],
  ["גן חיים", 32.19507, 34.90564, 696, 239],
  ["להב", 31.37933, 34.86865, 693, 2023],
  ["ניר יפה", 32.56911, 35.24519, 692, 165],
  ["כפר פינס", 32.48394, 35.00237, 691, 189],
  ["שדה משה", 31.61133, 34.80146, 690, 18],
  ["ברעם", 33.05799, 35.43417, 689, 667],
  ["עבדון", 33.04806, 35.18002, 687, 892],
  ["טללים", 30.99211, 34.77005, 686, 1177],
  ["עזר", 31.73673, 34.67114, 686, 1149],
  ["רמת רזיאל", 31.77379, 35.07320, 684, 460],
  ["נתיב הל\"ה", 31.68832, 34.98292, 682, 693],
  ["אלישיב", 32.38087, 34.90967, 681, 204],
  ["משמר השרון", 32.35661, 34.90349, 680, 194],
  ["שרונה", 32.72616, 35.46643, 680, 292],
  ["מרחב עם", 30.88758, 34.82820, 679, 1340],
  ["תעוז", 31.80104, 34.97471, 679, 752],
  ["בית מאיר", 31.79408, 35.03665, 678, 751],
  ["כרמל", 31.43152, 35.18280, 678, 3656],
  ["שלווה", 31.56371, 34.76713, 678, 873],
  ["בית נקופה", 31.80458, 35.12583, 676, 672],
  ["יד נתן", 31.65238, 34.70557, 676, 775],
  ["בית ניר", 31.64845, 34.87278, 675, 16],
  ["רמות מאיר", 31.87384, 34.85615, 675, 735],
  ["שלומית", 31.16805, 34.30536, 675, 1364],
  ["רימונים", 31.93390, 35.34075, 673, 3565],
  ["רגבים", 32.52381, 35.03450, 670, 444],
  ["בית עוזיאל", 31.87052, 34.90523, 669, 301],
  ["גלאון", 31.63377, 34.84758, 669, 393],
  ["הררית", 32.84568, 35.36661, 669, 1203],
  ["כנרת (מושבה)", 32.72455, 35.56456, 669, 63],
  ["דחי", 32.62105, 35.34431, 668, 475],
  ["תלמי יפה", 31.61817, 34.61351, 668, 744],
  ["כפר חיים", 32.35419, 34.90030, 667, 193],
  ["כפר מרדכי", 31.83148, 34.75479, 666, 764],
  ["גן שלמה", 31.87814, 34.79876, 665, 144],
  ["דגניה א'", 32.70800, 35.57478, 664, 62],
  ["ניר עציון", 32.69953, 34.99048, 660, 769],
  ["פרוד", 32.93194, 35.43203, 660, 599],
  ["בת שלמה", 32.60043, 35.00355, 659, 33],
  ["לביא", 32.78741, 35.44200, 659, 585],
  ["גן הדרום", 31.80433, 34.70085, 658, 1072],
  ["תל תאומים", 32.44206, 35.49582, 658, 1283],
  ["תלם", 31.56320, 35.03159, 655, 3719],
  ["כמהין", 30.91074, 34.43145, 648, 1291],
  ["סגולה", 31.66969, 34.78037, 647, 2046],
  ["קלחים", 31.44940, 34.67791, 647, 414],
  ["אשכולות", 31.39136, 34.90269, 646, 3722],
  ["שקף", 31.51491, 34.93596, 646, 1233],
  ["בלפוריה", 32.63008, 35.29655, 643, 94],
  ["בת הדר", 31.64729, 34.59679, 643, 1323],
  ["גליל ים", 32.15719, 34.83077, 641, 346],
  ["חלץ", 31.57803, 34.65855, 640, 820],
  ["שדה יואב", 31.64513, 34.67719, 640, 293],
  ["אייל", 32.21178, 34.97969, 639, 716],
  ["שדי תרומות", 32.44050, 35.48588, 638, 2057],
  ["אביטל", 32.55750, 35.30711, 637, 2052],
  ["יפתח", 33.12871, 35.55167, 636, 453],
  ["שרשרת", 31.40451, 34.60293, 635, 398],
  ["בית חנן", 31.93366, 34.77329, 632, 159],
  ["גבעת ניל\"י", 32.54776, 35.04141, 631, 360],
  ["יזרעאל", 32.56215, 35.32105, 627, 452],
  ["צוחר", 31.23635, 34.42571, 627, 1136],
  ["כפר שמאי", 32.95675, 35.45720, 626, 605],
  ["נחם", 31.76636, 35.00336, 626, 809],
  ["נצר חזני", 31.82125, 34.86269, 626, 1372],
  ["שער הגולן", 32.68708, 35.60408, 626, 264],
  ["דמיידה", 32.81537, 35.22765, 624, 1317],
  ["גבע", 32.56629, 35.37208, 622, 86],
  ["כפר חיטים", 32.80110, 35.50274, 622, 255],
  ["שורשים", 32.89314, 35.25956, 622, 1235],
  ["אל -רום", 33.18075, 35.77126, 621, 4003],
  ["כפר רופין", 32.45777, 35.55663, 620, 295],
  ["עמיעד", 32.92810, 35.54101, 618, 385],
  ["בצת", 33.07118, 35.13489, 617, 589],
  ["אשרת", 32.97172, 35.15686, 616, 1256],
  ["תל קציר", 32.70450, 35.61753, 616, 719],
  ["מגדל עוז", 31.64014, 35.14265, 615, 3561],
  ["כפר דניאל", 31.93383, 34.93240, 614, 707],
  ["דברת", 32.64785, 35.34953, 613, 407],
  ["רחוב", 32.45080, 35.48915, 612, 854],
  ["אושה", 32.79625, 35.11462, 611, 278],
  ["בית הערבה", 31.80798, 35.47658, 609, 3645],
  ["רמת רחל", 31.73954, 35.21865, 609, 127],
  ["נחשון", 31.83134, 34.95589, 608, 777],
  ["בית יוסף", 32.55934, 35.55163, 607, 265],
  ["גלעד (אבן יצחק)", 32.55722, 35.07644, 606, 369],
  ["עין הוד", 32.69979, 34.98309, 604, 74],
  ["כרמים", 31.33381, 34.91808, 601, 1198],
  ["גיתית", 32.10203, 35.39662, 600, 3613],
  ["כפר ביאליק", 32.82131, 35.08654, 600, 220],
  ["פני חבר", 31.48606, 35.16547, 600, 3723],
  ["מיטב", 32.54586, 35.30081, 595, 2054],
  ["מלילות", 31.38951, 34.59522, 594, 2044],
  ["עין עירון", 32.48350, 35.00927, 594, 223],
  ["אלי-עד", 32.80511, 35.73491, 593, 4002],
  ["נגוהות", 31.49309, 34.98345, 592, 3724],
  ["עופר", 32.62232, 34.98200, 592, 810],
  ["עין גב", 32.78281, 35.63896, 592, 273],
  ["ניר אליהו", 32.19732, 34.94893, 586, 808],
  ["מנות", 33.03854, 35.19470, 585, 1205],
  ["קליה", 31.75023, 35.46711, 585, 3601],
  ["עין חרוד (איחוד)", 32.56363, 35.39114, 583, 89],
  ["צובה", 31.78354, 35.11946, 583, 465],
  ["דריג'את", 31.30106, 35.07577, 581, 1349],
  ["ירדנה", 32.56527, 35.56468, 581, 2026],
  ["נחל עוז", 31.47277, 34.49746, 579, 844],
  ["שואבה", 31.79825, 35.07803, 579, 741],
  ["עלומים", 31.45228, 34.51334, 578, 1146],
  ["חלוץ", 32.95024, 35.31237, 576, 1272],
  ["אדורה", 31.55218, 35.01805, 575, 3759],
  ["איבים", 31.53372, 34.60973, 575, 338],
  ["משמר איילון", 31.87140, 34.94547, 573, 670],
  ["פצאל", 32.04409, 35.44231, 573, 3615],
  ["מבוא חמה", 32.73767, 35.65539, 568, 4204],
  ["ברקאי", 32.47531, 35.02954, 566, 617],
  ["קטורה", 29.96997, 35.06106, 565, 1052],
  ["גבעות עדן", 31.66304, 35.01317, 562, 1362],
  ["משאבי שדה", 31.00324, 34.78620, 562, 421],
  ["בית רבן", 31.81730, 34.72957, 561, 848],
  ["ברוש", 31.37051, 34.63301, 561, 2060],
  ["גבעולים", 31.39682, 34.59153, 560, 2014],
  ["אביבים", 33.08862, 35.47180, 555, 1115],
  ["אחוזם", 31.55340, 34.77020, 555, 821],
  ["שדה בוקר", 30.87327, 34.79317, 555, 885],
  ["אורות", 31.74219, 34.73451, 553, 2012],
  ["ניר יצחק", 31.23768, 34.35765, 551, 402],
  ["שדה ניצן", 31.23015, 34.41932, 551, 1058],
  ["מכמנים", 32.90675, 35.32638, 548, 1202],
  ["תל יוסף", 32.55624, 35.39958, 546, 84],
  ["זרועה", 31.45849, 34.62411, 544, 2064],
  ["כפר חרוב", 32.76274, 35.66333, 544, 4004],
  ["כנף", 32.86963, 35.69991, 543, 4028],
  ["אלמגור", 32.91210, 35.60239, 541, 1125],
  ["מגן", 31.29974, 34.42695, 540, 695],
  ["שלוחות", 32.47129, 35.48045, 540, 439],
  ["בית אורן", 32.73091, 35.00490, 536, 317],
  ["עין זיוון", 33.09647, 35.79603, 534, 4503],
  ["גבעת ח\"ן", 32.16764, 34.87441, 532, 207],
  ["טפחות", 32.86848, 35.42216, 531, 1214],
  ["צוריאל", 33.00677, 35.31376, 530, 774],
  ["ספיר", 30.61484, 35.18417, 528, 1176],
  ["אילנייה", 32.75429, 35.40733, 527, 49],
  ["אמנון", 32.90464, 35.57264, 526, 1253],
  ["מבקיעים", 31.62215, 34.57689, 526, 573],
  ["מעוז חיים", 32.49308, 35.55036, 524, 272],
  ["ריחן", 32.46818, 35.13621, 523, 3568],
  ["שער מנשה", 32.44741, 35.01474, 523, 921],
  ["כסלון", 31.77408, 35.04930, 522, 859],
  ["גדעונה", 32.54868, 35.35901, 521, 442],
  ["כרם ביבנה (ישיבה)", 31.81840, 34.72236, 520, 1094],
  ["כורזים", 32.91075, 35.55091, 519, 1252],
  ["ניר משה", 31.47747, 34.63091, 518, 2047],
  ["תלמי יוסף", 31.20137, 34.36203, 517, 1237],
  ["לבנים", 32.86380, 35.49456, 516, 1230],
  ["דוב\"ב", 33.05177, 35.40722, 515, 1067],
  ["רמות נפתלי", 33.10155, 35.55330, 515, 372],
  ["אלוני הבשן", 33.04403, 35.83872, 512, 4017],
  ["חמדיה", 32.52039, 35.51984, 509, 343],
  ["שפר", 32.94361, 35.43619, 507, 846],
  ["בית גוברין", 31.61302, 34.89595, 504, 619],
  ["דור", 32.60757, 34.92172, 503, 738],
  ["כחל", 32.89073, 35.51071, 503, 1210],
  ["מלכייה", 33.10073, 35.51071, 499, 596],
  ["פדויים", 31.32693, 34.61116, 496, 750],
  ["נטף", 31.83193, 35.06762, 495, 1254],
  ["מסילות", 32.49559, 35.47413, 494, 298],
  ["צאלים", 31.20370, 34.53417, 493, 413],
  ["מבואות יריחו", 31.90584, 35.41813, 492, 3825],
  ["קוממיות", 31.66161, 34.73074, 486, 766],
  ["זנוח", 31.73251, 34.99922, 485, 816],
  ["מחסיה", 31.74781, 35.00732, 485, 776],
  ["נאות הכיכר", 30.93372, 35.37824, 485, 1124],
  ["מרגליות", 33.21486, 35.54492, 484, 843],
  ["נחשונים", 32.06109, 34.94915, 484, 705],
  ["אלומות", 32.70685, 35.54640, 482, 330],
  ["תירוש", 31.75066, 34.88598, 482, 10],
  ["משואה", 32.11267, 35.49090, 481, 3605],
  ["שדמה", 31.83205, 34.74141, 481, 555],
  ["תלמי אליהו", 31.22901, 34.42903, 480, 1051],
  ["רעים", 31.38552, 34.45932, 479, 713],
  ["רוויה", 32.44874, 35.47341, 478, 2016],
  ["קריית ענבים", 31.81055, 35.11946, 477, 78],
  ["גנות", 32.01794, 34.82853, 476, 836],
  ["אניעם", 32.95728, 35.74014, 475, 4012],
  ["נועם", 31.56802, 34.78887, 475, 15],
  ["תושייה", 31.43379, 34.54088, 474, 1083],
  ["ראס אל-עין", 32.91432, 35.37250, 473, 1334],
  ["גדות", 33.01912, 35.61967, 472, 35],
  ["נירים", 31.33597, 34.39494, 472, 602],
  ["גבעת עוז", 32.55487, 35.19855, 470, 703],
  ["אבטליון", 32.83642, 35.35175, 466, 1275],
  ["עדנים", 32.13939, 34.90532, 466, 2035],
  ["הבונים", 32.63663, 34.93271, 465, 675],
  ["הילה", 33.03642, 35.24428, 464, 1208],
  ["נתיב השיירה", 32.99402, 35.13567, 462, 792],
  ["מצר", 32.44005, 35.04749, 461, 648],
  ["תאשור", 31.37182, 34.64322, 461, 2062],
  ["גשר", 32.62055, 35.55119, 458, 305],
  ["עוזה", 31.59319, 34.76430, 457, 826],
  ["אורים", 31.30419, 34.52263, 454, 403],
  ["דקל", 31.19551, 34.34613, 453, 1241],
  ["כפר המכבי", 32.79007, 35.11595, 452, 254],
  ["שעל", 33.11647, 35.71816, 452, 4009],
  ["נווה אור", 32.58884, 35.55324, 451, 590],
  ["נס עמים", 32.96615, 35.12121, 450, 1143],
  ["צבעון", 33.02496, 35.41618, 450, 1213],
  ["בת חן", 32.36009, 34.87235, 449, 1361],
  ["שני", 31.35590, 35.06994, 449, 1287],
  ["אבן מנחם", 33.07423, 35.29393, 448, 1081],
  ["שדי אברהם", 31.21139, 34.33702, 447, 1223],
  ["יבול", 31.18927, 34.31811, 446, 1232],
  ["כרכום", 32.92977, 35.60794, 445, 1285],
  ["שושנת העמקים", 32.35413, 34.85699, 445, 224],
  ["תומר", 32.01871, 35.43884, 444, 3558],
  ["גורן", 33.05659, 35.23633, 439, 755],
  ["ברק", 32.54280, 35.26485, 438, 141],
  ["עגור", 31.69768, 34.91220, 438, 794],
  ["צפרירים", 31.66008, 34.94393, 438, 1079],
  ["מורן", 32.92162, 35.39372, 436, 1163],
  ["חמדת", 32.25133, 35.52618, 431, 3646],
  ["סאסא", 33.02731, 35.39415, 431, 578],
  ["שיבולים", 31.39571, 34.60758, 431, 865],
  ["גבולות", 31.21084, 34.46549, 430, 352],
  ["גזר", 31.87672, 34.91983, 430, 370],
  ["מי עמי", 32.50474, 35.14767, 430, 1128],
  ["שומרה", 33.08311, 35.28378, 428, 614],
  ["אדירים", 32.54901, 35.27197, 427, 113],
  ["מקווה ישראל", 32.02920, 34.78135, 423, 22],
  ["אבשלום", 31.19546, 34.33105, 422, 1311],
  ["גפן", 31.74075, 34.87853, 422, 39],
  ["ורד יריחו", 31.82650, 35.43307, 420, 3639],
  ["פרזון", 32.54577, 35.31077, 420, 2053],
  ["דישון", 33.08216, 35.51898, 419, 2063],
  ["קריית שלמה", 32.23423, 34.86147, 419, 412],
  ["אילות", 29.58148, 34.96283, 418, 1126],
  ["תובל", 32.92893, 35.24472, 418, 1172],
  ["גאולי תימן", 32.39226, 34.90165, 415, 872],
  ["קלע", 33.13172, 35.68396, 415, 4024],
  ["חבצלת השרון", 32.36061, 34.86275, 410, 235],
  ["עמיחי", 32.04552, 35.32751, 409, 3824],
  ["גונן", 33.12434, 35.64690, 405, 852],
  ["גיבתון", 31.88887, 34.80000, 405, 196],
  ["עין תמר", 30.94322, 35.37414, 405, 1251],
  ["אפיק", 32.77832, 35.70110, 402, 4301],
  ["כפר רות", 31.90989, 35.03070, 402, 1166],
  ["משגב עם", 33.24775, 35.54848, 401, 378],
  ["יראון", 33.07741, 35.45526, 400, 623],
  ["משכיות", 32.31773, 35.50384, 397, 3785],
  ["כפר גליקסון", 32.50554, 35.00435, 394, 310],
  ["חזון", 32.90649, 35.39489, 388, 1047],
  ["פרי גן", 31.22169, 34.35541, 388, 1231],
  ["גני הדר", 31.87844, 34.85370, 387, 1103],
  ["זוהר", 31.59540, 34.69262, 387, 44],
  ["באר מילכה", 30.93288, 34.40736, 385, 1278],
  ["צוקים", 30.49126, 35.16633, 384, 1262],
  ["אחווה", 31.74358, 34.76923, 383, 1157],
  ["מיצר", 32.76708, 35.73597, 379, 4019],
  ["מסד", 32.84387, 35.42310, 379, 1258],
  ["עין השלושה", 31.35148, 34.40158, 379, 676],
  ["מלאה", 32.56354, 35.23756, 377, 164],
  ["שזור", 32.93317, 35.35273, 375, 527],
  ["אורטל", 33.08693, 35.75869, 374, 4013],
  ["ניר עוז", 31.31079, 34.40175, 373, 69],
  ["שתולה", 33.08525, 35.31417, 373, 1045],
  ["כחלה", 31.28980, 35.05327, 372, 1367],
  ["יהל", 30.08356, 35.12824, 371, 1158],
  ["מסדה", 32.68365, 35.59832, 370, 263],
  ["ניצן ב'", 31.73639, 34.63671, 370, 1419],
  ["אדמית", 33.07929, 35.20855, 368, 1068],
  ["גבעת שפירא", 32.35744, 34.87665, 366, 1077],
  ["ירקונה", 32.14520, 34.89913, 365, 183],
  ["גדיש", 32.55890, 35.24482, 359, 145],
  ["גשור", 32.81884, 35.71700, 357, 4022],
  ["כיסופים", 31.37526, 34.39910, 357, 840],
  ["כפר גדעון", 32.64406, 35.29130, 355, 106],
  ["מחנה יתיר", 31.34743, 35.06014, 353, 1196],
  ["כפר רוזנואלד (זרעית)", 33.10007, 35.28836, 351, 1130],
  ["שדות מיכה", 31.72116, 34.92045, 348, 27],
  ["אלמוג", 31.78893, 35.46127, 347, 3556],
  ["עין חוד", 32.69152, 34.99982, 345, 1320],
  ["נטועה", 33.06470, 35.32350, 343, 1147],
  ["גורנות הגליל", 33.05998, 35.24920, 341, 1219],
  ["דבורה", 32.55280, 35.26401, 339, 146],
  ["גרופית", 29.94121, 35.06450, 338, 1129],
  ["נעמ\"ה", 31.90671, 35.46781, 337, 3713],
  ["בית ינאי", 32.38133, 34.86346, 335, 200],
  ["נווה שלום", 31.81799, 34.97865, 332, 1259],
  ["רותם", 32.33698, 35.51910, 330, 3782],
  ["פורייה - כפר עבודה", 32.71959, 35.54670, 327, 1104],
  ["חרשים", 32.95664, 35.32800, 324, 1209],
  ["קדרים", 32.89803, 35.47425, 324, 1211],
  ["גן שורק", 31.94492, 34.76106, 322, 311],
  ["חורשים", 32.13765, 34.97109, 319, 355],
  ["הראל", 31.80903, 34.94947, 315, 464],
  ["מנרה", 33.19624, 35.54454, 315, 347],
  ["אודם", 33.19346, 35.74950, 314, 4010],
  ["ניצנה (קהילת חינוך)", 30.88614, 34.42151, 311, 1195],
  ["כפר מל\"ל", 32.16808, 34.89400, 307, 98],
  ["אבירים", 33.03853, 35.28687, 304, 1220],
  ["נווה ים", 32.67917, 34.93064, 302, 312],
  ["בית עובד", 31.92183, 34.77355, 300, 202],
  ["כלנית", 32.87510, 35.45559, 298, 1229],
  ["ורדון", 31.66378, 34.78195, 295, 1133],
  ["חרמש", 32.42339, 35.11898, 295, 3717],
  ["מדרשת רופין", 32.34216, 34.91196, 294, 897],
  ["אבנת", 31.67845, 35.43663, 292, 3786],
  ["מצפה שלם", 31.56763, 35.40077, 291, 3610],
  ["צור נתן", 32.24077, 35.01318, 291, 1148],
  ["גיתה", 32.96709, 35.24897, 290, 1206],
  ["נווה איתן", 32.49200, 35.53176, 288, 296],
  ["חמרה", 32.19872, 35.43600, 286, 3609],
  ["סואעד (חמירה)", 32.76736, 35.16817, 285, 942],
  ["אלקוש", 33.03328, 35.32385, 282, 603],
  ["נורית", 32.54193, 35.35633, 281, 833],
  ["יפית", 32.06361, 35.47390, 279, 3566],
  ["גני עם", 32.15136, 34.90151, 278, 218],
  ["נאות סמדר", 30.04973, 35.02665, 274, 1197],
  ["יעף", 32.26794, 34.96637, 271, 1044],
  ["לוטן", 29.98779, 35.08716, 270, 1255],
  ["מכורה", 32.16503, 35.42333, 270, 3614],
  ["בן שמן (כפר נוער)", 31.95944, 34.92739, 269, 1084],
  ["גת רימון", 32.06843, 34.88024, 267, 128],
  ["יד השמונה", 31.80925, 35.08980, 265, 1134],
  ["סופה", 31.23732, 34.34215, 265, 1238],
  ["צביה", 32.88967, 35.33174, 263, 1180],
  ["הר עמשא", 31.34347, 35.10203, 258, 1261],
  ["בית ברל", 32.20108, 34.92627, 254, 1076],
  ["בקעות", 32.24287, 35.45309, 254, 3612],
  ["סמר", 29.83233, 35.02252, 254, 1156],
  ["כפר סילבר", 31.67315, 34.61176, 253, 107],
  ["בית חוגלה", 31.82124, 35.50686, 242, 3864],
  ["כישור", 32.94607, 35.25003, 233, 1153],
  ["כרם שלום", 31.22770, 34.28432, 232, 1085],
  ["מתת", 33.04106, 35.35756, 232, 1184],
  ["מיטל", 32.43859, 35.41325, 227, 1154],
  ["נווה אטי\"ב", 33.26223, 35.74168, 226, 4303],
  ["ידידה", 31.81327, 35.10556, 225, 1144],
  ["צוקי ים", 32.36133, 34.85892, 223, 1102],
  ["חולית", 31.23068, 34.32573, 222, 1239],
  ["נתיב הגדוד", 31.98861, 35.44459, 222, 3555],
  ["גלגל", 31.99949, 35.44691, 221, 3606],
  ["ביתן אהרן", 32.36514, 34.87017, 217, 252],
  ["פלך", 32.93382, 35.23335, 215, 1185],
  ["גיזו", 31.80493, 34.93891, 214, 1043],
  ["אל -עריאן", 32.49788, 35.12517, 210, 1316],
  ["אליפז", 29.79502, 35.01130, 208, 1248],
  ["האון", 32.72520, 35.62191, 207, 702],
  ["נעורים", 32.37407, 34.86204, 207, 186],
  ["כפר חסידים ב'", 32.74987, 35.08752, 195, 889],
  ["אל -עזי", 31.72197, 34.79864, 192, 1339],
  ["ארסוף", 32.21375, 34.81639, 192, 1324],
  ["כדיתה", 33.00472, 35.46414, 192, 1338],
  ["אמציה", 31.53242, 34.91373, 190, 23],
  ["מבוא מודיעים", 31.93349, 34.98727, 187, 1141],
  ["ארגמן", 32.17262, 35.52317, 184, 3598],
  ["ייט\"ב", 31.94750, 35.42356, 183, 3607],
  ["רביד", 32.85084, 35.46434, 177, 1225],
  ["כפר עבודה", 32.25646, 34.94084, 174, 875],
  ["אשבל", 32.87660, 35.30502, 172, 1276],
  ["נווה זוהר", 31.15281, 35.36512, 166, 1057],
  ["כפר גלים", 32.76622, 34.95891, 161, 427],
  ["כפר זוהרים", 31.62133, 34.92485, 160, 1325],
  ["שחרות", 29.90434, 34.99997, 157, 1266],
  ["נערן", 31.96779, 35.45525, 155, 3620],
  ["עמוקה", 32.99808, 35.52476, 153, 1212],
  ["אשל הנשיא", 31.32592, 34.69744, 151, 2021],
  ["לפידות", 32.95889, 35.26183, 149, 1173],
  ["מצפה", 32.79007, 35.50964, 149, 58],
  ["רועי", 32.24756, 35.48930, 148, 3619],
  ["כדורי", 32.70292, 35.40578, 147, 371],
  ["נווה חריף", 30.03801, 35.03724, 146, 1279],
  ["מאיר שפיה", 32.59123, 34.97131, 141, 102],
  ["שיזף", 31.00216, 34.76521, 137, 1378],
  ["כרם בן שמן", 31.95836, 34.93305, 132, 88],
  ["בית צבי", 32.71972, 34.96968, 122, 212],
  ["עיינות", 31.91558, 34.76785, 122, 156],
  ["מבואות ים", 32.40326, 34.86824, 112, 1318],
  ["רמת הנשיא טראמפ", 33.13226, 35.69066, 111, 4029],
  ["הודיות", 32.78857, 35.43517, 108, 1322],
  ["עין חצבה", 30.79853, 35.24591, 107, 1053],
  ["אורנים", 32.71206, 35.10900, 106, 882],
  ["כפר הנוער הדתי", 32.74303, 35.09828, 106, 890],
  ["אלוני יצחק", 32.51037, 35.00402, 96, 868],
  ["עזוז", 30.79238, 34.47272, 94, 328],
  ["דייר ראפאת", 31.77650, 34.94714, 86, 493],
  ["בית זיד", 32.70130, 35.12993, 84, 353],
  ["כנות", 31.80196, 34.75213, 82, 2006],
  ["רוח מדבר", 30.98164, 34.73348, 80, 1341],
  ["קריית יערים (מוסד)", 31.81161, 35.10412, 65, 2039],
  ["נווה אבות", 32.48523, 34.96764, 60, 926],
  ["איתנים", 31.77852, 35.09574, 54, 886],
  ["אבו ג'ווייעד (שבט)", 31.23044, 35.04221, 0, 967],
  ["אבו סריחאן (שבט)", 31.26165, 34.85842, 0, 935],
  ["אבו עבדון (שבט)", 31.30219, 34.84252, 0, 958],
  ["אבו עמאר (שבט)", 31.19421, 34.94785, 0, 1042],
  ["אבו עמרה (שבט)", 31.23004, 34.84279, 0, 932],
  ["אבו קורינאת (שבט)", 31.13112, 34.96899, 0, 968],
  ["אבו רובייעה (שבט)", 31.23947, 35.05269, 0, 966],
  ["אבו רוקייק (שבט)", 31.18513, 34.91640, 0, 961],
  ["אביגיל", 31.40284, 35.14098, 0, 3869],
  ["אורון", 30.91090, 35.01605, 0, 1771],
  ["אזור תעסוקה משגב(תרדיון)", 32.86722, 35.27309, 0, 1724],
  ["אזור תעשייה אכזיב (מילואות)", 33.06694, 35.10884, 0, 1726],
  ["אזור תעשייה הר-טוב", 31.76484, 34.98413, 0, 1701],
  ["אזור תעשייה נעמן (מילואות)", 32.88201, 35.09428, 0, 1727],
  ["אטרש (שבט)", 31.26815, 34.93715, 0, 965],
  ["אילון תבור*", 32.63504, 35.36291, 0, 1716],
  ["אסד (שבט)", 31.32482, 34.87395, 0, 960],
  ["אעצם (שבט)", 31.14001, 34.90605, 0, 963],
  ["אפיניש (שבט)", 31.31154, 34.98955, 0, 959],
  ["בי\"ס אזורי מקיף (אשר)", 33.00974, 35.15054, 0, 1725],
  ["בית חולים פוריה", 32.75272, 35.54041, 0, 1712],
  ["בר-לב", 32.90690, 35.18801, 0, 1728],
  ["ג'נאביב (שבט)", 31.21239, 35.03175, 0, 976],
  ["גבעות הרואה", 32.05905, 35.27466, 0, 3862],
  ["גבעת חביבה", 32.45807, 35.02168, 0, 1740],
  ["גבעת שמש", 31.77489, 34.95165, 0, 566],
  ["הוואשלה (שבט)", 31.12218, 35.02143, 0, 1169],
  ["הוזייל (שבט)", 31.40831, 34.74957, 0, 956],
  ["זבארגה (שבט)", 31.23674, 35.03380, 0, 2742],
  ["ח'ואלד (שבט)", 32.75919, 35.15699, 0, 986],
  ["חוג'ייראת (ד'הרה) (שבט)", 32.83455, 35.29409, 0, 948],
  ["ים המלח - בתי מלון", 31.19879, 35.36232, 0, 1772],
  ["יעל", 32.55189, 35.30811, 0, 1117],
  ["מגדל תפן", 32.97542, 35.27612, 0, 1722],
  ["מחנה הילה*", 31.90591, 34.69217, 0, 1411],
  ["מחנה טלי*", 30.75140, 34.66705, 0, 1418],
  ["מחנה יהודית*", 32.66443, 35.17826, 0, 1413],
  ["מחנה יוכבד*", 29.93137, 34.93043, 0, 1416],
  ["מחנה יפה*", 31.22043, 34.67491, 0, 1415],
  ["מחנה מרים*", 31.75273, 34.72468, 0, 1414],
  ["מחנה תל נוף*", 31.83422, 34.81933, 0, 1412],
  ["מסעודין אל-עזאזמה (שבט)", 31.19658, 34.81459, 0, 939],
  ["מפעלי ברקן", 32.10247, 35.11766, 0, 1791],
  ["מפעלי גליל עליון", 33.19326, 35.57201, 0, 1706],
  ["מפעלי גרנות", 32.44494, 34.95408, 0, 1739],
  ["מפעלי העמק (יזרעאל)", 32.66448, 35.23561, 0, 1717],
  ["מפעלי חבל מודיעים", 32.00885, 34.95998, 0, 1729],
  ["מפעלי ים המלח(סדום)", 31.03044, 35.36906, 0, 1775],
  ["מפעלי כנות", 31.80150, 34.75943, 0, 1753],
  ["מפעלי מישור רותם", 31.05376, 35.18995, 0, 1773],
  ["מפעלי מעון", 31.29331, 34.43022, 0, 1769],
  ["מפעלי צומת מלאכי", 31.72317, 34.75049, 0, 1761],
  ["מפעלי צין - ערבה", 30.84442, 35.09004, 0, 1776],
  ["מפעלי צמח", 32.70347, 35.58749, 0, 1711],
  ["מפעלי שאן", 32.49664, 35.51830, 0, 1719],
  ["מרכז אזורי כדורי", 32.70617, 35.40509, 0, 1713],
  ["מרכז אזורי מרום הגליל", 32.99668, 35.44070, 0, 1708],
  ["מרכז אזורי משגב", 32.85850, 35.25906, 0, 1723],
  ["מרכז אזורי שוהם", 31.99069, 34.94122, 0, 1747],
  ["מרכז כ\"ח", 33.12053, 35.57015, 0, 1705],
  ["מרכז מיר\"ב*", 32.64573, 34.96433, 0, 1715],
  ["משמר יהודה", 31.73630, 35.31985, 0, 3865],
  ["נאות חובב", 31.13515, 34.78566, 0, 1770],
  ["נמל תעופה בן-גוריון", 32.00611, 34.88612, 0, 1748],
  ["נמרוד", 33.24575, 35.75170, 0, 4035],
  ["נצאצרה (שבט)", 31.22149, 35.10520, 0, 1041],
  ["סואעד (כמאנה) (שבט)", 32.90773, 35.33884, 0, 989],
  ["סייד (שבט)", 31.28975, 34.91818, 0, 1170],
  ["עד הלום", 31.76229, 34.66290, 0, 1762],
  ["עוקבי (בנו עוקבה) (שבט)", 31.28434, 34.91610, 0, 957],
  ["עטאוונה (שבט)", 31.28346, 34.92870, 0, 969],
  ["עידן הנגב", 31.37740, 34.78698, 0, 1765],
  ["עין כרם-בי\"ס חקלאי", 31.77819, 35.15305, 0, 1056],
  ["עיר אובות", 30.81071, 35.24515, 0, 1187],
  ["עשהאל", 31.37332, 35.04345, 0, 3861],
  ["פארק תעשיות ספירים", 31.51631, 34.59465, 0, 1763],
  ["פארק תעשיות עמק חפר", 32.40173, 34.89556, 0, 1745],
  ["צופייה", 31.85643, 34.73884, 0, 1111],
  ["קבועה (שבט)", 31.23956, 35.16816, 0, 1234],
  ["קדמה", 31.70096, 34.77501, 0, 392],
  ["קודייראת א-צאנע (שבט)", 31.29365, 35.11562, 0, 964],
  ["קוואעין (שבט)", 31.32060, 35.02105, 0, 972],
  ["קמה (אזור תעשייה חקלאית)", 31.44086, 34.76028, 0, 1767],
  ["קריית חינוך מרחבים*", 31.31463, 34.59825, 0, 1768],
  ["קרית חינוך עזתה", 31.43064, 34.59216, 0, 1766],
  ["קרית תעופה", 31.98882, 34.91256, 0, 1746],
  ["שחרית", 32.08841, 35.07422, 0, 3868],
  ["שיטים", 30.17725, 35.01596, 0, 1267],
  ["שלווה במדבר", 30.83190, 34.73570, 0, 1373],
  ["שלומציון", 32.09836, 35.49341, 0, 1793],
  ["תל חי (מכללה)", 33.23547, 35.57895, 0, 1707],
  ["תעשיון דלתון", 33.02673, 35.47954, 0, 1709],
  ["תעשיון השרון", 32.27564, 34.92137, 0, 1741],
  ["תעשיון חבל יבנה", 31.81755, 34.67154, 0, 1750],
  ["תעשיון חצב*", 32.06471, 34.96188, 0, 1742],
  ["תעשיון ימין", 32.17736, 34.95355, 0, 1744],
  ["תעשיון מבצע*", 31.77053, 34.75364, 0, 1754],
  ["תעשיון מיתרים", 31.37309, 35.00564, 0, 1794],
  ["תעשיון נווה אילן", 31.80611, 35.09228, 0, 1702],
  ["תעשיון נוף אדום", 29.89513, 35.06644, 0, 1760],
  ["תעשיון צריפין", 31.96308, 34.85330, 0, 1749],
  ["תעשיון ראם*", 31.75751, 34.78747, 0, 1755],
  ["תעשיון שח\"ק", 32.47486, 35.17980, 0, 1792],
  ["תעשיות גליל תחתון", 32.78522, 35.46283, 0, 1714],
  ["תראבין א-צאנע (שבט)", 31.16684, 34.82205, 0, 970],
];
